module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b902700357964e91d7799c48947b4f3a.png";